import { useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
//import FaultRepairCard from './FaultRepairCard'
//import { FaultRepairCardData } from '../../data/CardData'
import { fetchFirebaseToken } from "../../firebase.js";


const FaultRepairCardList = () => {
    const navigate = useNavigate()
    const redirectDashboardPage = () => {
        Swal.fire({
            html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
            showCancelButton: true,
            confirmButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
            cancelButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
                popup: "custom-popup",
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                navigate("/dashboard");
            } else {
                navigate("/faultRepair");
            }
        });
    }
    const redirectToFRassignment = () => {
        navigate("/faultRepairAssignments");
    }

    const redirectToFRDotSR = () => {
        navigate("/faultRepairDotSr");
    }

    const redirectTPfaultRepair = () => {
        navigate("/falutRepairTp");
    }

    const isMobileDevice = () => {
        return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    };

 
    useEffect(() => {
        const fetchData = async () => {
            let gmcToken = sessionStorage.getItem('gmcToken');
            try {
                if (isMobileDevice()) {
                    if (!gmcToken || gmcToken === 'undefined') {
                        console.warn("⚠️ gmcToken not found, generating new token...");
                        gmcToken = await fetchFirebaseToken(); // Await to get the token
                    }
                    if (!gmcToken || gmcToken === 'undefined') {
                        console.warn("❗ Skipping saveDeviceToken API: gmcToken still not available");
                    } else {
                        const ApiUrl = process.env.REACT_APP_API_URL;
                        const RequestBody = {
                            "Action": "saveDeviceToken",
                            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                            "user_name": sessionStorage.getItem('userEmail'),
                            "user_token": sessionStorage.getItem('gmcToken')
                        };
                        const Response = await fetch(ApiUrl, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(RequestBody),
                        });
                        const response = await Response.json();
                        // console.log("response",response)
                        if (response) {
                            try {
                                const ApiUrl = "https://oneml.spectra.co/getNotificationDetailsForFFA";
                                const RequestBody = {
                                    "Action": "saveDeviceToken",
                                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                                    "user_name": sessionStorage.getItem('userEmail'),
                                    "user_token": sessionStorage.getItem('gmcToken') || ""
                                };
                                const Response = await fetch(ApiUrl, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify(RequestBody),
                                });
                                const response = await Response.json();
                                // console.log("response",response)

                            } catch (error) {
                                console.error("Error fetching  data:", error);
                            }
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching  data:", error);
            }
        };
        fetchData();

    }, []);

    return (
        <>
            <div className="container-fluid text-light Header-style header" >
                <div className="p-3">
                    <span className='' style={{ cursor: 'pointer' }} onClick={redirectDashboardPage}>
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className='p-1 m-3'>Menu</span>
                </div>
            </div>
            <div className="container-fluid faultRepair-main">
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {/* {FaultRepairCardData.map((data, id) => (
                        <div className="col" key={id}>
                            <FaultRepairCard title={data.title} />
                        </div>
                    ))} */}
                    <div className="col">
                        <div className="card mb-3 mt-2 shadow-sm">
                            <div className="m-2 " style={{ display: "inline-flex" }} onClick={redirectToFRassignment}>
                                <p className="card-text overflow-hidden">Your Assignment</p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card mb-3 mt-2 shadow-sm">
                            <div className="m-2 " style={{ display: "inline-flex" }} onClick={redirectToFRDotSR}>
                                <p className="card-text overflow-hidden">DoT SRs</p>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card mb-3 mt-2 shadow-sm">
                            <div className="m-2 " style={{ display: "inline-flex" }} onClick={redirectTPfaultRepair}>
                                <p className="card-text overflow-hidden">TP Fault Repair</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FaultRepairCardList
